import React from 'react';
import './Testimonials.css';
import { ChevronLeft, ChevronRight } from 'lucide-react';

function TestimonialCard({ content }) {
  return (
    <div className="testimonial-card">
      <div className="quote-container">
        <span className="quote-mark left-quote">"</span>
        <p className="testimonial-content">{content}</p>
        <span className="quote-mark right-quote">"</span>
      </div>
    </div>
  );
}

function Testimonials() {
  const testimonials = [
    { content: "I had already known Sharen for many years prior to starting my business in 2003. When I needed an accountant I only had one person in mind. I approached Sharen and we have been working together ever since. I like to work with professionals and Sharen definitely is just that." },
    { content: "Sharen has been our accountant for nearly 15 years. She has always provided an excellent service and been very helpful and patient with any queries we might have had. We would highly recommend Sharen." },
    { content: "Sharen Cain has been my accountant stretching back into the last century. There are many reasons for this, and I cannot thank her enough for all the great work she has done for me over this considerable time, and hopefully for many years to come" },
    { content: "Sharen has looked after my financial affairs for many years, including both personal tax returns and several family businesses. She has ensured that VAT, CIS and annual returns are filed on time and without error. I would be very happy to recommend her services." },
    { content: "We have placed all our personal & corporate tax planning, bookkeeping & VAT returns with Sharen Cain FCCA for over 20 years. They are responsive, proactive and supportive and we really appreciate the personal service we get from the team. They are always available and approachable." },
    { content: "It's always been a pleasure to deal with Sharen. She has taken care of me, from self employed to business owner over the last 15 years." },
    { content: "We have used Sharen Cain for many years and have always had very professional helpful service. We have and would again recommend this company." },
    { content: "We have been working with you for many years always happy to help nothing is too much trouble and very polite and give good advice highly recommend." },
    { content: "Sharen Cain has been my accountant stretching back into the last century. There are many reasons for this, and I cannot thank her enough for all the great work she has done for me over this considerable time, and hopefully for many years to come." }
  ];

  const scroll = (direction) => {
    const container = document.getElementById('testimonials-container');
    const scrollAmount = direction === 'left' ? -900 : 900;
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  return (
    <div className="testimonials">
      <div className="testimonials-container">
        <h1>What Our Clients Say</h1>
        
        <div className="testimonials-carousel">
          <button 
            className="scroll-button left"
            onClick={() => scroll('left')}
          >
            <ChevronLeft size={24} />
          </button>
          
          <div id="testimonials-container" className="testimonials-wrapper">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard key={index} content={testimonial.content} />
            ))}
          </div>
          
          <button 
            className="scroll-button right"
            onClick={() => scroll('right')}
          >
            <ChevronRight size={24} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;